import React from "react";
import { Radio, Button, Spin } from "antd";
import FileDrop from "react-file-drop";
import { formatMoneyValue } from "utils/utils";
import "./MakePaymentTab.scss";
import DbsPayNowInstructionsPanel from "./paymentinstructions/DbsPayNowInstructionsPanel";
import BankTransferInstructionsPanel from "./paymentinstructions/BankTransferInstructionsPanel";
import { getSearchParamValueByName } from "utils/utils";

import {uploadInvoice} from "api/api";
import { displayGenericError } from "common/notifications";
import {downloadOrderReceipt} from "../../api/api";

const RadioGroup = Radio.Group;

export default class MakePaymentTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentMethod: this.initPaymentMethod(), //DBS_PAY_NOW
      invoiceUploading: false,
      order: this.props.order,
      currentCustomer: this.props.currentCustomer,
      isLoading: false
    };
  }

  initPaymentMethod = () => {
    const { payment } = this.props;
    if (!!!payment) {
      return getSearchParamValueByName("sourceCurrency") === "SGD"
        ? "DBS_PAY_NOW"
        : "BANK_TRANSFER";
    }
    return payment.sourceValue.currency === "SGD"
      ? "DBS_PAY_NOW"
      : "BANK_TRANSFER";
  };

  onPaymentMethodChanged = newPaymentMethod => {
    this.setState({
      paymentMethod: newPaymentMethod
    });
  };

  handleInvoiceDrop = (files, event) => {
    this.doUploadFile(files[0]);
  };

  handleUploadClick = () => {
    this.refs.fileUploader.click();
  };

  onUploadedFileChanged = event => {
    let file = event.target.files[0];
    this.doUploadFile(file);
  };
  // doUploadFile = file => {
  //   const order =
  //     Object.keys(this.state.order).length > 0
  //       ? this.state.order
  //       : JSON.parse(localStorage.getItem("order"));
  //   const orderId = order.id || getSearchParamValueByName("orderId");
  //   this.setState({
  //     invoiceUploading: true
  //   });
  //   uploadInvoice(orderId, file)
  //     .then(response => {
  //       this.setState({
  //         invoiceUploading: false,
  //         order: {
  //           ...order,
  //           invoiceFileName: response.invoiceFileName
  //         }
  //       });
  //     })
  //     .catch(error => {
  //       displayGenericError(error);
  //       this.setState({
  //         invoiceUploading: false
  //       });
  //     });
  // };

  doUploadFile = file => {
    const order =
        Object.keys(this.state.order).length > 0
            ? this.state.order
            : JSON.parse(localStorage.getItem("order"));
    const id = order.id || getSearchParamValueByName("orderId");
    this.setState({
      invoiceUploading: true
    });
    const fileType = 'CUSTOMER_PAYMENT_SLIP';
    const otherTypeDescription = '';
    const remarks = 'Uploaded Invoice';
    uploadInvoice({
      id,
      fileType,
      otherTypeDescription,
      remarks,
      file
    })
        .then(response => {
          let invoice = response.filter(file => file.attachedFileType == 'CUSTOMER_PAYMENT_SLIP');
          this.setState({
            invoiceUploading: false,
            invoiceFileName: invoice[0].name,
          });
        })
        .catch(error => {
          this.setState({
            invoiceUploading: false
          });
          displayGenericError(error);
        });
  };

  downloadOrder = () => {
    if (Object.keys(this.state.order).length === 0) {
      let order_id = getSearchParamValueByName("order_id");
      let orderId = getSearchParamValueByName("orderId");
      downloadOrderReceipt('order',order_id, orderId);
    } else {
      downloadOrderReceipt('order',this.state.order.id, this.state.order.orderId);
    }
  };

  render() {
    const radioStyle = {
      height: "30px",
      lineHeight: "30px"
    };
    const payment = this.props.payment || {
      sourceValue: {
        currency: getSearchParamValueByName("sourceCurrency"),
        amount: getSearchParamValueByName("sourceAmount")
      }
    };

    const currentCustomer = this.state.currentCustomer;
    const initPaymentMethod = this.initPaymentMethod();
    return (
      <div style={{ visibility: this.props.visibility }}>
        <h4 className="bp-page-headline">Select Payment Method</h4>
        <div className="bp-page-body select-payment-method">
          <RadioGroup
            className={"bp-radio-custom"}
            defaultValue={this.state.paymentMethod}
            onChange={event => this.onPaymentMethodChanged(event.target.value)}
          >
            {initPaymentMethod === "DBS_PAY_NOW" && (
              <Radio style={radioStyle} value="DBS_PAY_NOW">
                OCBC PayNow
              </Radio>
            )}
            <Radio style={radioStyle} value="BANK_TRANSFER">
              Bank Transfer
            </Radio>
          </RadioGroup>
        </div>
            <h4 className="bp-page-headline">Instructions to fund your transaction of {formatMoneyValue(payment.sourceValue)}</h4>
        <div className="bp-page-body payment-instructions">
          {this.state.paymentMethod === "DBS_PAY_NOW" &&
            initPaymentMethod === "DBS_PAY_NOW" && (
              <DbsPayNowInstructionsPanel payment={payment} currentCustomer={currentCustomer}/>
            )}
          {this.state.paymentMethod === "BANK_TRANSFER" && (
            <BankTransferInstructionsPanel payment={payment} currentCustomer={currentCustomer}/>
          )}
        </div>
        <h4 className="bp-page-headline">
          Upload proof of payment to Brdgx
        </h4>
        <div className="bp-page-body upload-proof-payment">
          <p>
            By providing payment proof, it will help us verify your transfer and
            speed up the transaction.
          </p>
          <Spin spinning={this.state.invoiceUploading}>
            <div className="bp-margin-top-smallest">
              <input
                type="file"
                id="file"
                ref="fileUploader"
                style={{ display: "none" }}
                onChange={this.onUploadedFileChanged}
              />
              <FileDrop onDrop={this.handleInvoiceDrop}>
                <Button
                  className="dropzone-button"
                  onClick={this.handleUploadClick}
                >
                  {this.state.invoiceFileName ? (
                    this.state.invoiceFileName
                  ) : (
                    <div>
                      <span className={"icon"}>
                        <svg
                          width="29"
                          height="27"
                          viewBox="0 0 29 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M20.9312 2.16658C22.3242 3.42364 23.235 5.08015 23.5446 6.89525C26.664 7.70588 28.944 10.6371 28.95 13.9325C28.95 15.7534 28.2654 17.5039 27.0093 18.8667C25.7472 20.2413 24.0506 21.0636 22.2349 21.1929H22.1754H17.7581C17.3117 21.1929 16.9545 20.8404 16.9545 20.3999C16.9545 19.9593 17.3117 19.6069 17.7581 19.6069H22.1456C25.015 19.3895 27.3427 16.8519 27.3427 13.9325C27.3427 11.1775 25.3424 8.76322 22.6933 8.31679C22.3361 8.25805 22.0622 7.97021 22.0265 7.6119C21.6932 4.16965 18.794 1.57329 15.2816 1.57329C12.6682 1.57329 10.2632 3.07707 9.14994 5.4091C8.97134 5.77917 8.53677 5.95539 8.14386 5.81441C7.82239 5.69693 7.47711 5.63819 7.12588 5.63819C5.48282 5.63819 4.14337 6.95987 4.14337 8.58113C4.14337 8.93945 4.2029 9.27427 4.32196 9.59148C4.45293 9.95567 4.31006 10.361 3.97073 10.5548C2.51221 11.3948 1.60734 12.9456 1.60734 14.608C1.60734 17.1809 3.65521 19.4659 6.09004 19.6127H11.1859C11.6324 19.6127 11.9896 19.9652 11.9896 20.4057C11.9896 20.8463 11.6324 21.1988 11.1859 21.1988H6.06622H6.0186C4.39935 21.1106 2.88131 20.3529 1.73236 19.0723C0.613171 17.8211 0 16.241 0 14.6139C0 12.599 0.99417 10.7076 2.63128 9.53273C2.57175 9.22728 2.53603 8.91595 2.53603 8.59287C2.53603 6.09637 4.59581 4.06392 7.12588 4.06392C7.42354 4.06392 7.72119 4.09329 8.00694 4.14616C8.66774 3.00658 9.60238 2.03735 10.7275 1.3207C12.0789 0.457207 13.6564 -0.000976562 15.2757 -0.000976562C17.3712 -0.000976562 19.3833 0.768532 20.9312 2.16658ZM19.3001 14.2445C19.6156 14.5559 19.6156 15.0552 19.3001 15.3665C18.9846 15.6778 18.4786 15.6778 18.169 15.3665L15.2818 12.5175V25.611C15.2818 26.0515 14.9246 26.404 14.4781 26.404C14.0316 26.404 13.6744 26.0515 13.6744 25.611V12.5175L10.7872 15.3665C10.6324 15.5251 10.424 15.6015 10.2216 15.6015C10.0192 15.6015 9.81085 15.5192 9.65607 15.3665C9.34056 15.0552 9.34056 14.5559 9.65607 14.2445L13.9125 10.0445C14.0614 9.89181 14.2697 9.80957 14.4781 9.80957C14.6865 9.80957 14.8948 9.89768 15.0436 10.0445L19.3001 14.2445Z"
                            fill="#9B9B9B"
                          />
                        </svg>
                      </span>
                      Drag your payment receipt here or
                      <span className={"text-link"}>browse</span>
                    </div>
                  )}
                </Button>
              </FileDrop>
            </div>
          </Spin>
        </div>
        <div className="bp-padded-top-panel bp-buttons-panel">
          <Button
            type="primary"
            size="large"
            className="btn-wide-md"
            onClick={this.props.onCompleted}
          >
            Payment Completed
          </Button>
          <Button
           type="primary"
            size="large"
            className="btn-wide-md"
            onClick={this.props.onCompleted}
          >
            Pay Later
          </Button>
          <a href="#" onClick={this.downloadOrder}>Receipt</a>
        </div>
      </div>
    );
  }
}
